export default __webpack_public_path__ + "static/media/profile.56f1da75.jpg";